<template>
    <div></div>
</template>

<script>
    import L from "leaflet";
    import { findRealParent } from "vue2-leaflet";
    import LeafletSearch from "./leaflet-search.src.js";

    export default {
        name: "SearchStation",

        data(){
            return{
                marker_group: []
            }
        },

        /*
        * Recibe los array de la API que trae las estaciones
        */

        props:{
            hydrometereologicalStations:{
                default: [],
                type: [] 
            },
            nonTelemetricMetereologicalStations:{
                default: [],
                type: [] 
            },
            accelerographicStations:{
                default: [],
                type: []
            },
            phreatrimeticStations:{
                default: [],
                type: []
            },
            airqualityStations:{
                default: [],
                type: [] 
            }
        },

        /*
        * L.marker() añade la ubicación de las estaciones y el nombre,
        * cada grupo de estaciones se va creando como L.marker()
        * y se almacena en el array marker_group
        */

        watch:{
            hydrometereologicalStations(newState){
                for(var i in newState){
                    let marker = new L.marker(
                        [newState[i].latitude,newState[i].longitude],
                        {title:newState[i].name}
                    );
                    this.marker_group.push(marker);
                }
                this.fill_markers();
            },

            nonTelemetricMetereologicalStations(newState){
                for(var i in newState){
                    let marker = new L.marker(
                        [newState[i].latitude,newState[i].longitude],
                        {title:newState[i].name}
                    );
                    this.marker_group.push(marker);
                }
                this.fill_markers();
            },

            accelerographicStations(newState){
                for(var i in newState){
                    let marker = new L.marker(
                        [newState[i].latitude,newState[i].longitude],
                        {title:newState[i].name}
                    );
                    this.marker_group.push(marker);
                }
                this.fill_markers();
            },

            phreatrimeticStations(newState){
                for(var i in newState){
                    let marker = new L.marker(
                        [newState[i].latitude,newState[i].longitude],
                        {title:newState[i].name}
                    );
                    this.marker_group.push(marker);
                }
                this.fill_markers();
            },

            airqualityStations(newState){
                for(var i in newState){
                    let marker = new L.marker(
                        [newState[i].latitude,newState[i].longitude],
                        {title:newState[i].name}
                    );
                    this.marker_group.push(marker);
                }
                this.fill_markers();
            }
        },

        methods: {
            leafletSearcInit() {
                LeafletSearch;
            },

            fill_markers(){

                /*
                * El array marker_group es convertido en un layerGroup()
                * y en L.Control.Search se agregan las opciones del panel de búsqueda
                * una de estas opciones es el layerGroup creado "layer:cites"
                */

                let cites = L.layerGroup(this.marker_group);

                this.parentContainer = findRealParent(this.$parent);
                this.parentContainer.mapObject.addControl(
                    new L.Control.Search({
                        layer: cites,
                        position:'topleft',
                        textPlaceholder: 'Buscar...' ,
                        circleLocation: true,
                        marker: L.circleMarker([0, 0], { radius: 40 }),
                        initial: false,
                        collapsed: false,
                        zoom: 17
                    })
                );
            }
        }
    };
</script>

<style scoped>
    @import "./leaflet-search.css";
</style>